// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "建筑设备施工经济与组织",
      "tec": "崔洁",
      "week": "6-13周",
      "add": "教学楼B座323能动"
    },
    0,
    0,
    0,
    0
  ],
  "2": [
    0,
    {
      "sub": "建筑设备自动化",
      "tec": "刘钧哲",
      "week": "1-8周",
      "add": "教学楼B座321能动"
    },
    0,
    0,
    0
  ],
  "3": [
    {
      "sub": "建筑设备施工经济与组织",
      "tec": "崔洁",
      "week": "6-13周",
      "add": "教学楼B座319能动"
    },
    0,
    0,
    0,
    0
  ],
  "4": [
    0,
    {
      "sub": "建筑设备自动化",
      "tec": "刘钧哲",
      "week": "1-8周",
      "add": "教学楼B座321能动"
    },
    0,
    0,
    0
  ],
  "5": [
    0,
    0,
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
